import { Component } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import { ViewportScroller, CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ScreenshotCarouselDialog } from './screenshot-carousel-dialog/screenshot-carousel-dialog';

@Component({
  selector: 'app-home-page',
  standalone: true,
  imports: [RouterLink, CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './home-page.html',
  styleUrl: './home-page.css',
})
export class HomePage {
  constructor(
    private router: Router,
    private scroller: ViewportScroller,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.router.events.subscribe(() => {
      const fragment = this.router.parseUrl(this.router.url).fragment;
      if (fragment) {
        this.scroller.scrollToAnchor(fragment);
      }
    });
  }

  /**
   * Opens the screenshot carousel dialog showing app feature previews.
   * Triggered by the "See how it works" button on the home page.
   */
  openScreenshots(): void {
    this.dialog.open(ScreenshotCarouselDialog, {
      width: '780px',
      maxWidth: '95vw',
      panelClass: 'screenshot-dialog',
    });
  }
}
